import { Box, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_CONTAINER_BORDER,
  DARK_CONTAINER_FIELDS_FLOATING,
  LIGHT_CONTAINER_BORDER,
  LIGHT_CONTAINER_FIELDS_FLOATING,
} = COLORS;

export const ProfileListSkeletonContainer = styled(Box)(({ theme }) => ({
  borderRadius: '8px',
  background: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_FLOATING : LIGHT_CONTAINER_FIELDS_FLOATING,
  padding: '10px',
  border: theme.palette.type === 'dark' ? `1px solid ${DARK_CONTAINER_BORDER}` : `1px solid ${LIGHT_CONTAINER_BORDER}`,
}));
